import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component, Fragment } from '@wordpress/element';
import { SelectControl } from '@wordpress/components';
import { getIdsFromQuery } from '@woocommerce/navigation';
import { find, isEqual, partial } from 'lodash';
import PropTypes from 'prop-types';
import interpolateComponents from 'interpolate-components';
import classnames from 'classnames';
/**
 * Internal dependencies
 */

import Search from '../search';
import { textContent } from './utils';

var SearchFilter =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchFilter, _Component);

  function SearchFilter(_ref) {
    var _this;

    var filter = _ref.filter,
        config = _ref.config,
        query = _ref.query;

    _classCallCheck(this, SearchFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchFilter).apply(this, arguments));
    _this.onSearchChange = _this.onSearchChange.bind(_assertThisInitialized(_this));
    _this.state = {
      selected: []
    };
    _this.updateLabels = _this.updateLabels.bind(_assertThisInitialized(_this));

    if (filter.value.length) {
      config.input.getLabels(filter.value, query).then(_this.updateLabels);
    }

    return _this;
  }

  _createClass(SearchFilter, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          config = _this$props.config,
          filter = _this$props.filter,
          query = _this$props.query;
      var prevFilter = prevProps.filter;

      if (filter.value.length && !isEqual(prevFilter, filter)) {
        var selected = this.state.selected;
        var ids = selected.map(function (item) {
          return item.key;
        });
        var filterIds = getIdsFromQuery(filter.value);
        var hasNewIds = filterIds.every(function (id) {
          return !ids.includes(id);
        });

        if (hasNewIds) {
          config.input.getLabels(filter.value, query).then(this.updateLabels);
        }
      }
    }
  }, {
    key: "updateLabels",
    value: function updateLabels(selected) {
      var prevIds = this.state.selected.map(function (item) {
        return item.key;
      });
      var ids = selected.map(function (item) {
        return item.key;
      });

      if (!isEqual(ids.sort(), prevIds.sort())) {
        this.setState({
          selected: selected
        });
      }
    }
  }, {
    key: "onSearchChange",
    value: function onSearchChange(values) {
      this.setState({
        selected: values
      });
      var _this$props2 = this.props,
          filter = _this$props2.filter,
          onFilterChange = _this$props2.onFilterChange;
      var idList = values.map(function (value) {
        return value.key;
      }).join(',');
      onFilterChange(filter.key, 'value', idList);
    }
  }, {
    key: "getScreenReaderText",
    value: function getScreenReaderText(filter, config) {
      var selected = this.state.selected;

      if (0 === selected.length) {
        return '';
      }

      var rule = find(config.rules, {
        value: filter.rule
      }) || {};
      var filterStr = selected.map(function (item) {
        return item.label;
      }).join(', ');
      return textContent(interpolateComponents({
        mixedString: config.labels.title,
        components: {
          filter: createElement(Fragment, null, filterStr),
          rule: createElement(Fragment, null, rule.label)
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          config = _this$props3.config,
          filter = _this$props3.filter,
          onFilterChange = _this$props3.onFilterChange,
          isEnglish = _this$props3.isEnglish;
      var selected = this.state.selected;
      var key = filter.key,
          rule = filter.rule;
      var input = config.input,
          labels = config.labels,
          rules = config.rules;
      var children = interpolateComponents({
        mixedString: labels.title,
        components: {
          title: createElement("span", {
            className: className
          }),
          rule: createElement(SelectControl, {
            className: classnames(className, 'woocommerce-filters-advanced__rule'),
            options: rules,
            value: rule,
            onChange: partial(onFilterChange, key, 'rule'),
            "aria-label": labels.rule
          }),
          filter: createElement(Search, {
            className: classnames(className, 'woocommerce-filters-advanced__input'),
            onChange: this.onSearchChange,
            type: input.type,
            placeholder: labels.placeholder,
            selected: selected,
            inlineTags: true,
            "aria-label": labels.filter
          })
        }
      });
      var screenReaderText = this.getScreenReaderText(filter, config);
      /*eslint-disable jsx-a11y/no-noninteractive-tabindex*/

      return createElement("fieldset", {
        className: "woocommerce-filters-advanced__line-item",
        tabIndex: "0"
      }, createElement("legend", {
        className: "screen-reader-text"
      }, labels.add || ''), createElement("div", {
        className: classnames('woocommerce-filters-advanced__fieldset', {
          'is-english': isEnglish
        })
      }, children), screenReaderText && createElement("span", {
        className: "screen-reader-text"
      }, screenReaderText));
      /*eslint-enable jsx-a11y/no-noninteractive-tabindex*/
    }
  }]);

  return SearchFilter;
}(Component);

SearchFilter.propTypes = {
  /**
   * The configuration object for the single filter to be rendered.
   */
  config: PropTypes.shape({
    labels: PropTypes.shape({
      placeholder: PropTypes.string,
      rule: PropTypes.string,
      title: PropTypes.string
    }),
    rules: PropTypes.arrayOf(PropTypes.object),
    input: PropTypes.object
  }).isRequired,

  /**
   * The activeFilter handed down by AdvancedFilters.
   */
  filter: PropTypes.shape({
    key: PropTypes.string,
    rule: PropTypes.string,
    value: PropTypes.string
  }).isRequired,

  /**
   * Function to be called on update.
   */
  onFilterChange: PropTypes.func.isRequired,

  /**
   * The query string represented in object form.
   */
  query: PropTypes.object
};
export default SearchFilter;
//# sourceMappingURL=search-filter.js.map